import { Type } from 'class-transformer';

export type CheckDeletableReasonsKeys =
  | 'b2b'
  | 'lounges'
  | 'air_payout'
  | 'air_luggage';

export enum CheckDeletableReasons {
  AIR_PAYOUT = 'air_payout',
  AIR_LUGGAGE = 'air_luggage',
  B2B = 'b2b',
  LOUNGES = 'lounges',
}

export interface IJourneyCheckDeletable {
  deletable: boolean;
  loungesIncluded: boolean;
  blockedBy: CheckDeletableReasonsKeys[];
}

export class JourneyCheckDeletable implements IJourneyCheckDeletable {
  deletable: boolean;
  loungesIncluded: boolean;
  blockedBy: CheckDeletableReasonsKeys[];

  @Type(() => Boolean)
  get blockedByB2b(): boolean {
    return this.blockedBy.includes(CheckDeletableReasons.B2B);
  }

  @Type(() => Boolean)
  get blockedByLounges(): boolean {
    return this.blockedBy.includes(CheckDeletableReasons.LOUNGES);
  }

  @Type(() => Boolean)
  get blockedByAirPayout(): boolean {
    return this.blockedBy.includes(CheckDeletableReasons.AIR_PAYOUT);
  }

  @Type(() => Boolean)
  get blockedByAirLuggage(): boolean {
    return this.blockedBy.includes(CheckDeletableReasons.AIR_LUGGAGE);
  }
}
